import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

export const WordCloudHC = function ({
  graphApiResponse,
  chartTitle,
  onEntityClick,
  isEmbededWidget,
  setGraphRef,
  setGraphRefList,
  mediaType,
  identifier,
}) {
  const ref = useRef();
  const [lineChartData, setLineChartData] = useState({});

  useEffect(() => {
    setGraphRef(ref);
  }, []);

  useEffect(() => {
    redrawChart();
  }, [graphApiResponse]);

  const redrawChart = () => {
    const options = {
      chart: {
        type: "wordcloud",
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      tooltip: {
        enabled: true,
      },
      plotOptions: {
        wordcloud: {
          minFontSize: 7,
          maxFontSize: 60,
          style: {
            padding: "0",
          },
        },
        series: {
          events: {
            click: (e) => handleWordClick(e),
          },
        },
      },
      // exporting: { enabled: false },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
        },
      },
      series: [
        {
          rotation: {
            from: 0,
            to: 0,
            orientations: 0,
          },
          data: graphApiResponse,
          name: "Count",
        },
      ],
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(identifier + mediaType, ref);
    }
  };

  function handleWordClick(e) {
    try {
      const {
        point: { name },
      } = e;
      if (!e || !name) {
        return;
      }
      onEntityClick(
        {},
        {
          keyword: name,
        }
      );
    } catch (e) {
      console.log("[Error]", e);
      return null;
    }
  }
  const uniqueIdentifier = isEmbededWidget
    ? `embedded-${identifier}`
    : identifier;

  return (
    <div
      id={uniqueIdentifier}
      className={isEmbededWidget ? "biggerWidget" : ""}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

WordCloudHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
};
